<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการผู้ให้บริการ (Operator)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการผู้ให้บริการ (Operator)
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="pull-right box_add">
                      <button 
                      v-if="user_permission.add"
                      @click="change_view" 
                      class="btn btn-info btn_custom">
                        <i class="fa fa-plus"></i> เพิ่มผู้ให้บริการ
                      </button>
                    </div>
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="formTable"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="คำค้นหา" prop="text">
                            <el-input v-model="formTable.text" placeholder="กรุณากรอกคำค้นหา เช่น ชื่อ - นามสกุล หรือ อีเมล" clearable></el-input>
                          </el-form-item>
                          <el-form-item label="ประเภทการให้บริการ" prop="service_type">
                            <el-select
                              v-model="formTable.provider_type"
                              @change="change_provider_type()"
                            >
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                              <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ชื่อผู้ให้บริการ" prop="provider">
                            <el-select v-model="formTable.provider_id" placeholder="โปรดเลือกชื่อผู้ให้บริการ">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <template v-for="item in options">
                                <el-option 
                                  v-if="!formTable.provider_type || formTable.provider_type == item.provider_type"
                                  :label="item.provider_name" 
                                  :key="item.id"  
                                  :value="item.id">
                                </el-option>
                              </template>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="เบอร์โทรศัพท์" prop="phone">
                            <el-input
                              maxlength="10"
                              show-word-limit
                              placeholder="090xxxxxxx"
                              v-model="formTable.phone"
                              @keypress.native="isNumberKey"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="สถานะ">
                            <el-checkbox-group v-model="formTable.status">
                              <el-checkbox label="Active"></el-checkbox>
                              <el-checkbox label="Inactive"></el-checkbox>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button @click="search(null)" type="button" class="btn btn-primary">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                  @query-change="search"
                    :data="operators"
                    :total="total"
                    :page-size="formTable.pageSize"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                    :table-props="tableProps"
                  >
                    <el-table-column prop="logo_pic" label="รูปภาพ" width="130">
                      <template slot-scope="scope">
                        <div class="img-radius">
                          <img
                            :src="config().API_URL+scope.row.profile_img"
                          />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="fullname" label="ชื่อ-นามสกุล" width="260" ></el-table-column>
                    <el-table-column sortable prop="email" label="อีเมล" width="260"></el-table-column>
                    <el-table-column sortable prop="phone_number" label="เบอร์โทรศัพท์" width="150"></el-table-column>
                    <el-table-column sortable prop="username" label="ชื่อผู้ใช้งาน" width="150"></el-table-column>
                    <el-table-column sortable="custom" prop="provider_name" label="ชื่อผู้ให้บริการ" width="200" ></el-table-column>
                    <el-table-column sortable prop="brand_name_th" label="ชื่อแบรนด์" width="120" ></el-table-column>
                    <el-table-column prop="status" label="สถานะ"></el-table-column>
                    <el-table-column label="จัดการ" align="center" width="200" fixed="right">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top">
                        <el-button
                          size="mini"
                          type="success"
                          @click="handleView(scope.$index, scope.row)"
                        >
                          <i class="el-icon-view"></i>
                        </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="แก้ไข" placement="top">
                        <el-button 
                        v-if="user_permission.edit"
                        :disabled="scope.row.status == 'Inactive'"
                        size="mini" 
                        type="primary" 
                        @click="handleEdit(scope.row)">
                          <i class="el-icon-edit"></i>
                        </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="ลบ" placement="top">
                        <el-button
                          v-if="user_permission.add"
                          :disabled="scope.row.status == 'Inactive'"
                          size="mini"
                          type="danger"
                          @click="handleDelete(scope.row.admin_id, scope.row.role_permission)"
                        >
                          <i class="el-icon-delete-solid"></i>
                        </el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <el-dialog :data="data_dialog" title="รายละเอียดผู้ให้บริการ" :visible.sync="dialogFormVisible">
                    <div class="box-img">
                      <div class="show_img">
                        <img
                          :src="config().API_URL+data_dialog.profile_img"
                        />
                      </div>
                    </div>
                    <div class="layout_detail_modal">
                      <div class="row">
                        <label for="ชื่อ-นามสกุล">ชื่อ-นามสกุล : {{ data_dialog.fullname }}</label>
                      </div>
                      <div class="row new-space-user">
                        <label for="อีเมล">อีเมล : {{ data_dialog.email }}</label>
                      </div>
                      <div class="row new-space-user">
                        <label for="เบอร์โทรศัพท์">เบอร์โทรศัพท์ : {{ data_dialog.phone_number }}</label>
                      </div>
                      <div class="row new-space-user">
                        <label for="ชื่อผู้ใช้งาน">ชื่อผู้ใช้งาน : {{ data_dialog.username }}</label>
                      </div>
                      <div class="row new-space-user">
                        <label for="ชื่อผู้ให้บริการ">ชื่อผู้ให้บริการ : {{ data_dialog.provider_name }}</label>
                      </div>
                      <div class="row new-space-user">
                        <label for="ชื่อผู้ให้บริการ">ประเภทการให้บริการ : {{ data_dialog.provider_type == 'mobile' ? 'โทรศัพท์เคลื่อนที่' : 'อินเทอร์เน็ตความเร็วสูงประจำที่' }}</label>
                      </div>
                    </div>
                  </el-dialog>
                  <el-dialog
                    title="ลบข้อมูลผู้ให้บริการ"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose"
                  >
                    <span>กรุณากดยืนยันการลบข้อมูล</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                      <el-button type="primary" @click="dialogVisible = false">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState,mapActions} from "vuex"
export default {
  data() {
    return {
      user_permission : {
        add : false,
        edit : false,
        delete : false
      },
      provider_list : [],
      dialogFormVisible: false,
      label_position: "top",
      data_dialog: {
        profile_img : null,
        fullname : null,
        email: null,
        phone_number: null,
        username: null,
        provider_name: null
      },
      dialogVisible: false,
      formTable: {
        text: "",
        provider_type: "",
        provider_id: "",
        status: ["Active"],
        phone: "",
        page: 1,
        pageSize: 10,
        sort: {
          order: null,
          prop: null
        }
      },
      tableProps: {
        border: true,
        stripe: true
      },
      data: []
    };
  },
  mounted(){
    this.get_provider()
    const permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_operator; 
    this.user_permission.add = permission.includes('add')
    this.user_permission.edit = permission.includes('edit')
    this.user_permission.delete = permission.includes('delete')
  },
  computed: {
    ...mapState({
      operators: store => store.Manage_operator.operators,
      total: store=> store.Manage_operator.total,
      options: store=> store.Manage_operator.select_lists,
      loading: store => store.Manage_operator.loading
    })
  },
  methods: {
    ...mapActions({
      search_table: "Manage_operator/search_table",
      get_provider: "Manage_operator/getAvailableOperator",
      remove: "Manage_operator/delete_permission",
      set_edit_info: "Manage_operator/set_edit_info"
    }),
    search(queryInfo){
      let formdata = Object.assign(this.formTable, queryInfo)
      this.search_table(this.formTable);
    },
    handleClose(done) {
      done();
    },
    change_view() {
      this.$router.push({ name: "Add_operator" });
    },
    handleView(index, row) {
      this.data_dialog = row;
      this.dialogFormVisible = !this.dialogFormVisible;
    },
    handleEdit(row) {
      this.set_edit_info({admin_id : row.admin_id})
    },
    handleDelete(id, permission) {
      const row = {id:id,permission:permission}
      this.$confirm("ลบออกจากรายชื่อผู้ให้บริการ", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
      .then(() => {
        this.remove(row);
      })
      .catch(() => {});
    },
    hide() {
      this.$modal.hide(modal_user);
    },
    change_provider_type(){
      this.provider_list = this.formTable.service_type == '' ? this.options : this.options.filter(item => item.provider_type == this.formTable.service_type) 
    }
  },
};
</script>
